import React from "react";
import { Col, Flex, Row } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { setCurrentForm, setIsLoggedIn, setModalOpen, setToken } from "@/reducers/commonSlice";

import Container from "@/components/container/Container";
import CardComponent from "@/components/card";
import BackWithLabel from "@/components/common/BackWithLabel";

import IconLogout from "@/components/icons/IconLogout";

import "@/styles/pages/settings.scss";
import IconPassword from "@/components/icons/IconPassword";
import { setCurrentGuide, setIsGuidePanel } from "@/reducers/guideSlice";

const Settings = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleLogout = () => {
    // get stage from local storage
    const stage = localStorage.getItem("stage");
    localStorage.clear();

    // set stage to local storage
    if (stage && stage !== "") {
      localStorage.setItem("stage", stage);
    }

    dispatch(setIsGuidePanel(false));
    dispatch(setIsLoggedIn(false));
    dispatch(setCurrentGuide({}));
    dispatch(setToken(""));
    navigate("/");
  };

  const handleChangePassword = () => {
    dispatch(setModalOpen(true));
    dispatch(setCurrentForm("changePassword"));
  };
  return (
    <Container className="setting-Wrapper">
      <CardComponent className="card">
        <div className="heading">
          <BackWithLabel label={"Settings"} path="/dashboard" />
        </div>
        <Row gutter={[16, 16]}>
          <Col xxl={6} xl={6} lg={8} md={24} sm={24} xs={24}>
            <div className="setting-chip body-b2" onClick={handleChangePassword}>
              <Flex gap={8} align="center">
                <IconPassword />
                Change Password
              </Flex>
            </div>
          </Col>
          <Col xxl={4} xl={4} lg={4} md={24} sm={24} xs={24}>
            <div className="setting-chip text-red body-b2" onClick={handleLogout}>
              <Flex gap={8}>
                <IconLogout />
                Logout
              </Flex>
            </div>
          </Col>
        </Row>
      </CardComponent>
    </Container>
  );
};

export default Settings;
